const de = {
  title: 'Merkliste',
  columns: {
    title: 'Titel',
    description: 'Beschreibung',
    category: 'Kategorie',
    delete: 'Eintrag Löschen',
    tooltip:
      'Ist ein Datum rot eingefärbt zeigt dies an, dass eine Aktion notwendig ist, oder heute etwas stattfindet.',
    startdate: 'Startdatum',
    releaseDate: 'Veröffentlichungsdatum',
    eventDate: 'Veranstaltungstag',
    notedOn: 'Gemerkt am',
    deadline: 'Stichtag am',
    noInfo: 'Keine Infos Vorhanden'
  }
};

export default de;
export type WatchlistTranslation = typeof de;
